import {ROLE_FOR_ADMINISTRATOR, ROLE_FOR_RESIDENT} from '../../../CodeMaster'
import {Room} from './Room'

export default class MeetingComment {
    meetingCommentId: number
    content: string
    user: CommentUser
    updateDatetime: string
    commentReactedUserList: CommentReactedUser[]
    attachmentList: CommentAttachment[]
    isYou: boolean
    version: number

    constructor(
        meetingCommentId: number,
        content: string,
        user: CommentUser,
        updateDatetime: string,
        commentReactedUserList: CommentReactedUser[],
        attachmentList: CommentAttachment[],
        isYou: boolean,
        version: number,
    ) {
        this.meetingCommentId = meetingCommentId
        this.content = content
        this.user = user
        this.updateDatetime = updateDatetime
        this.commentReactedUserList = commentReactedUserList
        this.attachmentList = attachmentList
        this.isYou = isYou
        this.version = version
    }
}

export interface CommentUser {
    familyName: string
    firstName: string
    role: ROLE_FOR_ADMINISTRATOR | ROLE_FOR_RESIDENT
    roomList: Room[]
    isWithinTerm: boolean
    hasMailAddress: boolean
}

export interface CommentReactedUser extends CommentUser {
    isYou: boolean
}

export interface CommentAttachment {
    id: number
    displayName: string
    uri: string
}
